export default __webpack_public_path__ + "static/media/sampleQbContactFile.6c623451.csv";